import { jsx } from "react/jsx-runtime";
import { Icon } from "../MainIcon/MainIcon.js";
import "@mui/material";
const OngoingCallIcon = ({ size = "md", ...rest }) => {
  return /* @__PURE__ */ jsx(Icon, { size, ...rest, children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M2.24023 15.1201H5.60023L7.28023 11.7601L9.52023 17.9201L12.3202 5.6001L15.1202 22.4001L18.4802 11.7601L20.7202 17.9201L22.4002 15.1201H25.7602",
      stroke: "white",
      strokeWidth: "2",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ) });
};
export {
  OngoingCallIcon
};
